import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Generic modal. Set whatever you want to put in this message box.
 */
class ModalGeneric extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: this.props.data.visible,
            bodyText: this.props.data.bodyText
        };
        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
        // Updates the parent (send it owns to state to update it)
        this.props.updateParent(this.state);
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="general.attention"/>
                    </ModalHeader>
                    <ModalBody>
                       <span dangerouslySetInnerHTML={{__html: this.state.bodyText}}/>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>
                            <Translate id="general.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalGeneric;